import classnames from 'classnames/bind'
import { ReactNode, useCallback } from 'react'
import { useTranslate } from 'react-polyglot'

import { BigLayoutIcon, SmallLayoutIcon } from '~/components/UI/Icons'

import { BUTTON } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface LayoutSwitcherProps {
  className?: string
  currentStep?: number
  onClickCallback?: (step: number) => void
}
interface LayoutSwitcherItemProps {
  className?: string
  index?: number
  onClick?: (step: number) => void
  isActive?: boolean
  children?: ReactNode
}

function LayoutSwitcherItem({
  className,
  index,
  isActive,
  onClick,
  children,
}: LayoutSwitcherItemProps) {
  const t = useTranslate()
  return (
    <button
      className={cx(className, css.switcher, { isActive })}
      aria-label={t(BUTTON.LAYOUT_SWITCHER(index))}
      onClick={(e) => {
        !isActive ? onClick(index) : null
      }}>
      {children}
    </button>
  )
}

function LayoutSwitcher({
  className,
  currentStep,
  onClickCallback,
}: LayoutSwitcherProps) {
  const onClickSwitcher = useCallback((step) => {
    onClickCallback && onClickCallback(step)
  }, [])

  return (
    <div className={cx(css.LayoutSwitcher, className)}>
      <LayoutSwitcherItem
        isActive={currentStep === 0}
        index={0}
        onClick={onClickSwitcher}>
        <BigLayoutIcon className={css.icon} />
      </LayoutSwitcherItem>
      <LayoutSwitcherItem
        isActive={currentStep === 1}
        index={1}
        onClick={onClickSwitcher}>
        <SmallLayoutIcon className={css.icon} />
      </LayoutSwitcherItem>
    </div>
  )
}

LayoutSwitcher.defaultProps = {}

export default LayoutSwitcher
